<div class="wrap text-center">
  <h1><a href="/">Daily Endgame Puzzle {{ puzzleId() }}</a></h1>
  <app-chessboard-view #chessboard [fen]="fen()"></app-chessboard-view>
  <div>
    {{ colorToMove() }} to move
  </div>
  <div class="d-flex flex-row justify-content-center flex-wrap gap-1">
    <button class="btn btn-secondary me-3" (click)="goToPuzzle()"><i class="bi bi-search"></i> Go to puzzle</button>
    <button class="btn btn-secondary me-3" (click)="previousPuzzle()"><i class="bi bi-arrow-left"></i> Previous puzzle</button>
    <button class="btn btn-secondary me-3" (click)="nextPuzzle()"><i class="bi bi-arrow-right"></i> Next puzzle</button>
    <button class="btn btn-primary me-3" (click)="openInLichess()"><i class="bi bi-diagram-3"></i> Open in Lichess</button>
  </div>
</div>
